import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const healthDataForm: Form<Child> = {
  key: 'healthData',
  fields: [
    {
      key: 'healthInsurance',
      label: 'Krankenkasse',
      fieldTypes: 'text',
    },
    {
      key: 'healthInsuranceNumber',
      label: 'Versicherungsnummer',
      fieldTypes: 'text',
    },
    {
      key: 'allergy',
      label: 'Allergien/Ernährung',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'medicine',
      label: 'Notfallmedikamente',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'vaccinations',
      label: 'Impfungen',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'uExamination',
      label: 'U-Untersuchung',
      fieldTypes: 'checkbox',
    },
    {
      key: 'healthAbnormalities',
      label: 'Auffälligkeiten',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
    {
      key: 'therapy',
      label: 'Therapie',
      fieldTypes: 'checkbox',
    },
    {
      key: 'healthNotice',
      label: 'Notizen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default healthDataForm;
